import { render, staticRenderFns } from "./CooldownProgressMenu.vue?vue&type=template&id=22c908e6&scoped=true"
import script from "./CooldownProgressMenu.vue?vue&type=script&lang=ts"
export * from "./CooldownProgressMenu.vue?vue&type=script&lang=ts"
import style0 from "./CooldownProgressMenu.vue?vue&type=style&index=0&id=22c908e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c908e6",
  null
  
)

export default component.exports